

import React, { useState, useContext } from 'react';

import { Button } from 'primereact/button';
import { Panel } from 'primereact/panel'

import AppContext from '../Context/AppContext';
import axios from '../axios';
import { useFormik } from 'formik';
import Modal from '../Widgets/Modal';

function CodeExecuteModal({ hide, data, update }) {
    const [visible, setVisible] = useState(true)
    const { toast, setBlocked, setCodeExecution, setTextMessageStatus, setPhoneDialStatus } = useContext(AppContext)

    var formik = useFormik({
        initialValues: data,
        validate: (data) => {
            let errors = {};
            return errors;
        },
        onSubmit: async (data) => {
            setVisible(false)
            setCodeExecution(true)
            setTextMessageStatus(0)
            setPhoneDialStatus(0)
            
            var textMessageStatus = 0;
            var phoneDialStatus = 0;

            if (data.text_message != null) {
                try {
                    const response_message = await axios.post('/external/send_text_message', data);
                    if (response_message.data.success) {
                        setTextMessageStatus(1)
                        textMessageStatus = 1
                    }
                    else {
                        setTextMessageStatus(2)
                        textMessageStatus = 2
                    }
                }
                catch (error) {
                    setTextMessageStatus(2)
                    textMessageStatus = 2
                }
            }
            else {
                setTextMessageStatus(1)
                textMessageStatus = 1
            }
            
            if (data.dial_number != null) {
                try {
                    const response_call = await axios.post('/external/dial_phone_number', { dial_number: data.dial_number, commands: data.phone_commands });
                    if (response_call.data.success) {
                        setPhoneDialStatus(1)
                        phoneDialStatus = 1
                    }
                    else {
                        setPhoneDialStatus(2)
                        phoneDialStatus = 2
                    }
                }
                catch (error) {
                    setPhoneDialStatus(2)
                    phoneDialStatus = 2
                }
            }
            else {
                setPhoneDialStatus(1)
                phoneDialStatus = 1
            }

            try {
                const status = (textMessageStatus == phoneDialStatus && textMessageStatus == 1) ? 1 : (textMessageStatus == phoneDialStatus && textMessageStatus == 2) ? 2 : 0
                if (data.logging) {
                    await axios.post('/logs/add', { id: data.id, status: 0 });
                }
            }
            catch (error) {

            }

            if (data.text_message != null || data.dial_number != null) {
                await new Promise(resolve => setTimeout(resolve, 5000));
            }

            setCodeExecution(false)
            update()
            //sendMessage(JSON.stringify({ type: `device_deleted` }))
            setVisible(false)
        }
    });

    const footer = (
        <React.Fragment>
            <Button label="Cancel" icon="pi pi-times" outlined onClick={() => { setVisible(false) }} />
            <Button label="Send" icon="pi pi-check" className="m-0" severity="danger" type='submit' form='delete-code' />
        </React.Fragment>
    );

    return (
        <Modal header="Confirmation" visible={visible} onHide={() => setVisible(false)} transitionOptions={{ onExited: () => hide() }} footer={footer}>
            <form onSubmit={formik.handleSubmit} id='delete-code' className='formgrid grid gap-3 mb-3'>
                <Panel className='col-12' header={
                    <div className="flex align-items-center">
                        <label className="flex-1 font-medium white-space-nowrap overflow-hidden text-overflow-ellipsis">Send code <b>{data.name}</b></label>
                    </div>
                } pt={{
                    header: { className: 'surface-hover' },
                    title: { className: 'w-full' }
                }}>
                    Are you sure you want to send this code ?
                </Panel>
            </form>
        </Modal>
    );
}

export default CodeExecuteModal;